import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../styles/NotFound.css';

/**
 * NotFound - Página 404 amigable
 * Se muestra cuando una ruta no existe
 */
const NotFound = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user.PortalRRHH === 1 || user.esAdmin === true;

  const handleGoHome = () => {
    if (isAdmin) {
      navigate('/administrador');
    } else {
      navigate('/home');
    }
  };

  return (
    <Container className="not-found-container d-flex align-items-center justify-content-center min-vh-100">
      <Card className="not-found-card text-center shadow-lg" style={{ maxWidth: '600px' }}>
        <Card.Body className="p-5">
          <div className="not-found-icon mb-4">
            <FaExclamationTriangle size={80} className="text-warning" />
          </div>
          
          <h1 className="display-4 mb-3">404</h1>
          <h3 className="mb-3">Página No Encontrada</h3>
          
          <p className="text-muted mb-4">
            Lo sentimos, la página que estás buscando no existe o ha sido movida.
            Esta funcionalidad puede no estar disponible o la ruta pudo haber cambiado.
          </p>

          <div className="d-flex gap-3 justify-content-center flex-wrap">
            <Button 
              variant="primary" 
              size="lg"
              onClick={handleGoHome}
              className="d-flex align-items-center gap-2"
            >
              <FaHome /> Volver al Inicio
            </Button>
            
            <Button 
              variant="outline-secondary" 
              size="lg"
              onClick={() => navigate(-1)}
            >
              ← Página Anterior
            </Button>
          </div>

          <p className="text-muted mt-4 mb-0 small">
            Si crees que esto es un error, contacta al administrador del sistema.
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default NotFound;
